<script setup lang="ts">
import { twMerge } from 'tailwind-merge'

const headerHeight = useHeaderHeight()
</script>

<template>
  <component :is="$attrs.is || 'div'" :class="twMerge('sticky', String($attrs.class))" data-sticky>
    <slot />
  </component>
</template>

<style scoped lang="postcss">
[data-sticky] {
  --_padding-top: var(--padding-top, theme('spacing.s'));
  top: calc(v-bind(headerHeight) + var(--_padding-top));
}
</style>
